import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ConnectionService } from '../../shared/services/Connection/connection.service';
import { CacheService } from '../../shared/services/Cache/cache.service';
import { ApiService } from '../../shared/services/API/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CartService } from '../../shared/services/Cart/cart.service';
import { typeInterface } from 'src/app/shared/Interfaces/company';

export interface Authentication{
 response: contentAuthentication;
}
export interface contentAuthentication{
  id_table:     string;
  tableNumber:  number;
  tableStatus:  number;
  cardNumber:   number;
  cardStatus:   number;
  id_company:   string;
}

@Injectable({
  providedIn: 'root',
})
export class verificationGuard implements CanActivate {

  constructor(
    private router: Router,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private apiService: ApiService,
    private cartService: CartService
  ){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const fullUrl = state.url;
    const qrCode = route.params['identification'];
    const [_, nameCompany, typeParam] = fullUrl.split('/');

    this.connection.updateNameCompany(nameCompany)

    if (!qrCode) {
      this.router.navigate(['/Authentication']);
      return false;
    }

    //Mesa/Comanda
    if (typeParam == 'QrCode') {
      return this.handleLocalFlow(qrCode, nameCompany);
    }
    else if(typeParam == 'Counter'){
      return this.handleCounterFlow(qrCode, nameCompany)
    }

    return false;

  }

  //Fluxo de Mesa e Comanda
  private handleLocalFlow(qrCode: string, nameCompany: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.getAuthentication(qrCode, nameCompany).subscribe(
        data => {
          const auth = data.response;
          const id_company = auth.id_company;
  
          const isComanda = auth.cardNumber !== 0;
          const number = isComanda ? auth.cardNumber : auth.tableNumber;
  
          //Verifica se existe pedido nesta Mesa/Comanda
          this.apiService.getOrderConsumption(isComanda ? number : 0, isComanda ? 0 : number, id_company).subscribe(
            (response) => {
              if (!response.orderEmpty) {
                this.orderSucess(response);
              } else {
                this.orderEmpty();
              }
            },
            () => this.router.navigate(['/Authentication'])
          );
  
          //Atuliza o status do pedido existente
          this.connection.updateRequestOrder((isComanda ? auth.cardStatus : auth.tableStatus) !== 20);
  
          //Objeto do tipo do cardápio
          const type: typeInterface = {
            type: isComanda ? 2 : 1,
            qrCodeNumber: qrCode,
            numberParam: number.toString()
          };

          //Atualiza o objeto
          this.connection.updateType(type);

          //Insere o cache do QrCode e elimina o cache do Balcão
          this.cacheService.setItemLocalTimeout('qrCode_key', qrCode, 120)
          this.cacheService.clearCacheTimeout('counter_key');

          //Verifica se existe carrinho em cache e elimina caso seja um carrinho do tipo Balcão ou Delivery
          const productsCache = this.cacheService.getItemLocalTimeout('product-cart')
          if(productsCache){
            if(productsCache.type == 3 || productsCache.type == 0){    
              this.cacheService.clearCacheTimeout('product-cart');
              console.log('Carrinho limpo');
            }

          }

          //Confirma que o Promisse foi concluida
          observer.next(true);
          observer.complete();

          setTimeout(() => this.router.navigate([ nameCompany, 'P']), 0);
        },
        error => {
          console.error('Erro ao obter autenticação:', error);
          this.router.navigate(['/Authentication']);
          observer.next(false);
          observer.complete();
        }
      );
    });
  }

  //Fluxo de Balcão
  private handleCounterFlow(counter: string, nameCompany: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {

      //Objeto do tipo do cardápio
      const type: typeInterface = {
        type: 3,
        qrCodeNumber: counter,
        numberParam: 0
      };
  
      //Atualiza o objeto
      this.connection.updateType(type);

      //Insere o cache do balcão e elimina o cache do QrCode
      this.cacheService.setItemLocalTimeout('counter_key', counter, 120);
      this.cacheService.clearCacheTimeout('qrCode_key');

      //Verifica se existe carrinho em cache e elimina caso seja um carrinho do tipo mesa ou comanda
      const productsCache = this.cacheService.getItemLocalTimeout('product-cart')
      if(productsCache){
        if(productsCache.type == 1 || productsCache.type == 2){
          this.cacheService.clearCacheTimeout('product-cart');
          console.log('Carrinho limpo');
        }
      }

      //Confirma que o Promisse foi concluida
      observer.next(true);
      observer.complete();

      setTimeout(() => this.router.navigate([ nameCompany, 'B']), 0);
    });
  }

  //Verificação para caso tenho pedido Mesa/Comanda
  private orderSucess(response: any){
    this.cartService.idTableCardSubject.next(response.response.orders[0].table.toString())
    this.cacheService.setItemLocal('number_local', response.response.orders[0].table)

    if(response.response.orders.length == 1)
    {
      this.cacheService.setItemLocal('session_id', response.response.orders[0].id_order)
    }
  }

  //Verificação para caso não tenha pedido Mesa/Comanda;
  private orderEmpty(){
    const session = this.cacheService.getItemLocal('session_id')
    if(session){
      this.cacheService.removeItemLocal('session_id')
    }
  }


}

